import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Typography,
} from '@mui/material'

import React from 'react'

interface LocationPermissionDialogProps {
  open: boolean
  onClose: () => void
}

const LocationPermissionDialog: React.FC<LocationPermissionDialogProps> = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="location-dialog-title" maxWidth="sm" fullWidth>
      <Box sx={{ p: 3 }}>
        <DialogTitle id="location-dialog-title" sx={{ textAlign: 'left', p: 1 }}>
          <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
            Oops...We can't find you!
          </Typography>
          <Divider sx={{ mt: 2, mb: 1 }} />
        </DialogTitle>

        <DialogContent sx={{ textAlign: 'left', p: 1 }}>
          <DialogContentText sx={{ mb: 2 }}>
            It looks like access to your location is disabled. <strong>Please use the description field</strong> to give
            location details so the trail crews know where to go!
          </DialogContentText>
          <DialogContentText>
            To enable this feature for future use, check your browser's location settings (the process varies by browser
            but is typically found in Site Settings or Privacy sections).
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ justifyContent: 'right', p: 0, pt: 2 }}>
          <Button
            onClick={onClose}
            variant="contained"
            color="primary"
            sx={{
              px: 4,
              py: 1,
              borderRadius: 1,
              textTransform: 'none',
              fontWeight: 'bold',
            }}
          >
            OKAY
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default LocationPermissionDialog
